import { render, staticRenderFns } from "./NoContentAvailable.vue?vue&type=template&id=0089c474"
import script from "./NoContentAvailable.vue?vue&type=script&lang=js"
export * from "./NoContentAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports